var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.61829 37.019L0.25116 8.09521H37.2512L33.8804 37.0144L18.7285 40.2314L3.61829 37.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7511 37.7723L30.9946 35.1729L33.8751 10.4601H18.7511V37.7723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7511 21.1876H12.6217L12.1984 17.555H18.7511V14.0076H7.13618L7.24706 14.9593L8.38552 24.7349H18.7511V21.1876ZM18.7511 30.4005L18.7309 30.4046L13.5721 29.3378L13.2423 26.5086H8.59249L9.24143 32.0785L18.7298 34.0958L18.7511 34.0913V30.4005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69357 0.234741H6.0475V2.01583H8.2008V0.234741H10.5548V5.62832H8.2009V3.82224H6.04761V5.62832H3.69378V0.234741H3.69357ZM13.6503 2.02333H11.5781V0.234741H18.0778V2.02333H16.0046V5.62832H13.6505L13.6503 2.02333ZM19.1092 0.234741H21.5637L23.0735 2.12989L24.5819 0.234741H27.0374V5.62832H24.6931V2.95497L23.0736 4.87269H23.0332L21.4125 2.95497V5.62832H19.1093V0.234741H19.1092ZM28.2089 0.234741H30.5635V3.84551H33.8738V5.62832H28.2089V0.234741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7352 21.1876V24.7349H24.4389L23.9013 29.3356L18.7352 30.4035V34.0941L28.231 32.0785L28.3007 31.4792L29.3891 22.1401L29.5022 21.1876H28.254H18.7352ZM18.7352 14.0076V17.555H29.9236L30.0166 16.7576L30.2276 14.9593L30.3384 14.0076H18.7352Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 40,
    fill: "white",
    transform: "translate(0.25116 0.233154)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.86bcffe15924cd2e0328336a0ffd0171.svg";
export { ForwardRef as ReactComponent };